import { useFetch } from "../hooks/useFetch"

import Close from '../img/close.png'
export default function Meaning({word , index}) {

    const {data} = useFetch(`https://api.dictionaryapi.dev/api/v2/entries/en/${word}`)

     const removeFav = () => {
     const storedFavs = JSON.parse(localStorage.getItem("my_words"));
     const filteredFavs = storedFavs.filter(w => w !== word)
     localStorage.setItem("my_words", JSON.stringify(filteredFavs));
      window.location.reload()
    }
  return (

    <>  
        {data && <div className="FavWord">
            <div className="FavWord-heading">
                <h3 className="">{index + 1} . {data[0].word} {data[0].phonetic && <span> ({data[0].phonetic})</span> }</h3>
                <img src={Close} alt="" onClick={()=> removeFav()}/>
            </div>
            {data[0].meanings.map((meaning , index) => {
                return (
                    <div key={index} className='FavWord-info'>
                        <p className="parts-of-speech">[{meaning.partOfSpeech}]</p>
                        <p className='def'>{meaning.definitions[0].definition}</p>
                        {meaning.definitions[0].example && <p className='example'>"{meaning.definitions[0].example}"</p>}
                    </div>)
                })
            }
        </div>}
    </>
  )
}
/* <div className='Learn'>
            <h1>Learn</h1>
            <div className='Learn-container'>
              {wordInfo && 
              <div className='Word'>
                    <div className='Word-heading'>
                        <h2>
                            {wordInfo[0].word}
                            {wordInfo[0].phonetic && <span> ({wordInfo[0].phonetic})</span> }
                        </h2>
                        <div className='fav' onClick={() => handleFav()}>
                            {favState ? <img src={HeartFill} alt=""/> : <img src={Heart} alt=""/>}
                            
                        </div>
                    </div>
                    {
                        wordInfo[0].meanings.map((meaning , index) => {
                           return (<div key={index} className='Word-info'>
                                <span className='parts-of-speech'>[{meaning.partOfSpeech}] </span> 
                                <p className='def'>{meaning.definitions[0].definition}</p>
                                {meaning.definitions[0].example && <p className='example'>"{meaning.definitions[0].example}"</p>}
                                                            
                            </div>)
                        })
                    }
                    <div className='next' onClick={() => {
                                setFavState(false)
                                let r = RandomWord()
                                setWord(r) 
                                checkFavs(r)

                            }
                           
                         }>
                        <img src={DownArrow} alt="" />
                    </div>
                </div>}
            </div>
        </div> */